import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { Field } from 'formik';
import debounce from 'lodash/debounce';
import { USER_EXISTS } from 'pages/Staff/StaffgraphQL';
import FormikInputField from 'components/Fields/FormikInputField';
import Loader from 'components/common/Loader';
import { modifiedUnderScore } from 'utils/constants';

const EmailFieldWithValidation = ({
  label,
  name,
  disabled = false,
  type,
  ...rest
}) => {
  const [isUserExists, { loading }] = useLazyQuery(USER_EXISTS, {
    fetchPolicy: 'network-only',
  });
  const [isEmailUnique, setIsEmailUnique] = useState(true);
  const [user, setUser] = useState(null);

  // Function to handle email validation
  const handleEmailValidation = async (email) => {
    if (email) {
      try {
        const { data } = await isUserExists({
          variables: {
            columnName: 'email',
            value: email,
          },
        });

        if (data?.isUserExists) {
          rest.updateFormIfUserExist(data?.isUserExists);
          setUser(data?.isUserExists);
          setIsEmailUnique(false);
        } else {
          rest.setFieldValue('userExist', false);
          setUser(null);
          setIsEmailUnique(true);
        }
      } catch (error) {
        console.error('Error checking email uniqueness:', error);
      }
    } else {
      setIsEmailUnique(true);
    }
  };

  const debouncedValidation = debounce((email) => {
    handleEmailValidation(email);
  }, 500);

  const handleChange = (e) => {
    rest.setFieldValue(name, e.target.value);
    debouncedValidation(e.target.value);
  };
  // useEffect(() => {
  //   if (!rest?.errors[name] && rest?.values[name]) {
  //     debouncedValidation(rest?.values[name]);
  //   }
  // }, [rest?.values[name]]);

  return (
    <div className="position-relative loading-input">
      <Field
        label={label}
        name={name}
        type={type}
        component={FormikInputField}
        disabled={disabled}
        onChange={handleChange}
        required
      />
      {loading && (
        <div className="loading">
          <Loader size="sm" />
        </div>
      )}
      {!isEmailUnique && user && (
        <div className="text-danger mb-3 errmsg f-12">
          This user already exist with{' '}
          {modifiedUnderScore(user?.roles?.map((r) => r.name).toString())}{' '}
          role(s)
        </div>
      )}
    </div>
  );
};

export default EmailFieldWithValidation;
